function addPriceInfoToProperties() {
  const breakdownDivs = document.querySelectorAll(
    ".cart-items__breakdown-data"
  );
  if (breakdownDivs.length === 0) return;

  breakdownDivs.forEach((div) => {
    const itemKey = div.getAttribute("data-item-breakdown");

    let breakdownJson = div.getAttribute("data-breakdown-json");
    if (!breakdownJson) return;

    let breakdown;
    try {
      breakdown = JSON.parse(breakdownJson);
    } catch (e) {
      return;
    }

    const itemRow = div.closest('[data-key="' + itemKey + '"]');
    if (!itemRow) return;

    const propertyDivs = itemRow.querySelectorAll(".cart-items__properties");

    propertyDivs.forEach((propDiv) => {
      const propertyName = propDiv.getAttribute("data-property");
      if (!propertyName) return;

      const priceInfo = breakdown[propertyName];
      if (!priceInfo) return;

      const dd = propDiv.querySelector("dd");
      if (!dd) return;

      if (dd.querySelector(".cart-items__price-info")) return;

      const priceSpan = document.createElement("span");
      priceSpan.className = "cart-items__price-info";
      priceSpan.textContent = " " + priceInfo;

      dd.appendChild(priceSpan);
    });

    if (breakdown["Base Price"]) {
      const bundleList = itemRow.querySelector(".cart-items__bundle");
      if (bundleList) {
        const lastLi = bundleList.querySelector("li:last-child");
        if (lastLi && !lastLi.querySelector(".cart-items__price-info")) {
          const priceSpan = document.createElement("span");
          priceSpan.className = "cart-items__price-info";
          priceSpan.textContent = " " + breakdown["Base Price"];
          lastLi.appendChild(priceSpan);
        }
      }
    }
  });
}

function init() {
  addPriceInfoToProperties();
}

function setupCartDrawerListener() {
  const cartDrawer = document.querySelector('cart-drawer-component');
  if (!cartDrawer) return;

  const observer = new MutationObserver(() => {
    setTimeout(() => init(), 50);
  });

  const drawerContent = cartDrawer.querySelector('dialog') || cartDrawer;
  observer.observe(drawerContent, { childList: true, subtree: true });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    init();
    setupCartDrawerListener();
  });
} else {
  init();
  setupCartDrawerListener();
}

document.addEventListener('cart:refresh', init);
document.addEventListener('cart:updated', init);
